export default __webpack_public_path__ + "static/media/error-black.486f8e4f.png";